import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import getHeadersformdata from './getHeaderFormdata'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { notify } from '../services/notification'



// Retrieve All Banner Image GET API
export const RetrieveAllBannerImageAction = (page, filter) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.RETRIVE_ALL_BANNER_IMAGE + "?" + `page=${page}&page_size=10`+ (filter ? `&is_active=${filter}` : '');
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {

      dispatch({ type: types.GET_RETRIVE_ALL_BANNER_IMAGE, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

// BANNER LIST Page Data
export const BannerListPageAction =
  (params = {}) =>
    (dispatch) => {
      dispatch({ type: types.BANNER_LIST_PAGE, payload: params ? params : null, });
    };

// Banner Filter data
export const BannerFilterAction = (params = {}) => dispatch => {
  dispatch({ type: types.BANNER_FILTER_DATA, payload: params ?  params : null })
}

// Banner Image Detail GET API
export const BannerImageDetailAction = (id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.BANNER_IMAGE_DETAIL + "/" + id
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.GET_BANNER_IMAGE_DETAIL, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

//Create Banner Image POST API
export const CreateBannerImageAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.CREATE_BANNER
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_CREATE_BANNER, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      const errorMessage = error.response.data.message;
      if(errorMessage){
        notify.error(errorMessage);
      }else{
        errorHandler(error)
      }
    }
  })
}

//Update Banner Image PUT API 
export const UpdateBannerImageAction = (params = {}, id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.UPDATE_BANNER + "/" + id
  let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.PUT_UPDATE_BANNER, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

//Banner Image IsActive View PUT  API
export const BannerImageIsActiveViewAction = (params = {}, id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.ACTIVE_BANNER + "/" + id
  let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.PUT_ACTIVE_BANNER, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      const errorMessage = error.response.data.msg;
      if(errorMessage){
        notify.error(errorMessage);
      }else{
        errorHandler(error)
      }
    }
  })
}

//update banner image sequence PUT  API
export const UpdateBannerImageSequenceAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.UPDATE_BANNER_IMAGE_SEQUENCE 
  let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.UPDATE_BANNER_IMAGE_SEQUENCE, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if(error.response.status === 400){
      const errorMessage = error.response.data.sequence[0];
      notify.error(errorMessage);
    }else{
      errorHandler(error)
    }
  })
}


//Delete Banner Image DELETE API
export const DeleteBannerImageAction = (id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.DELETE_BANNER + "/" + id
  let options = Object.assign({ method: 'DELETE' })
  options.headers = getHeadersformdata()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.DELETE_DELETE_BANNER, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}